module.exports = __webpack_public_path__ + "img/vikings-1.85878a94.png";